import { render, staticRenderFns } from "./ChatChart.vue?vue&type=template&id=f7e819e8&scoped=true"
import script from "./ChatChart.vue?vue&type=script&lang=js"
export * from "./ChatChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e819e8",
  null
  
)

export default component.exports